export default "__VITE_ASSET__f536b977__"